import React, {useState, useEffect} from 'react';

import {useRouter} from 'next/navigation';

import {LinearProgress, Button} from '@mui/material';

import Cookies from 'js-cookie';

import {useAuth} from '@/app/_contexts/AuthContext';
import {useAuthStatus} from '@/app/_contexts/AuthStatusContext';


const AuthButtons = () => {
    const router = useRouter();

    const {user, setUser} = useAuth();
    const {isAuthenticated, setIsAuthenticated, isStaff, setIsStaff, isSuperuser, setIsSuperuser} = useAuthStatus();


    // Registration
    const handleRegistration = () => {
        router.push('/account/registration');
    };

    // Login
    const handleLogin = () => {
        router.push('/account/login');
    };

    // Logout
    const handleLogout = async () => {
        try {
            const response = await fetch(
                '/api/accounts/logout/',
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );

            const result = await response.json();

            if (result.isLogout) {
                localStorage.removeItem('user');

                setUser(null);
                setIsSuperuser(false);
                setIsStaff(false);
                setIsAuthenticated(false);

                Cookies.remove('csrftoken');
                Cookies.remove('sessionid');

                router.push('/');
            } else {
                console.log("Invalid logout")
            }
        } catch (error) {
            console.log(error);
        }
    };


    if (isAuthenticated) {
        return (
            <>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={handleLogout}
                    sx={{my: 1, mx: 2}}
                >
                    Log Out
                </Button>
            </>
        );
    } else {
        return (
            <>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={handleRegistration}
                    sx={{my: 1, mx: 2}}
                >
                    Registration
                </Button>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={handleLogin}
                    sx={{my: 1, mx: 2}}
                >
                    Log In
                </Button>
            </>
        );
    }

};


export default AuthButtons;
